var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReminder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 500,
    viewBox: "0 0 528 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_10899",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_10899)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#FFEADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.075 267.665C110.498 267.665 86.1561 271.051 75.0576 272.744L128.669 323.534C171.934 312.435 258 290.603 214 280C167.16 268.714 129.798 267.665 119.075 267.665Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.446 271.642C84.8365 271.622 85.0429 271.615 85.0429 271.615L84.6828 272.314C86.3679 276.758 97.4875 301.035 140.537 305.037C187.973 309.446 207.582 278.361 207.582 278.361C207.582 278.361 236.5 282.5 248.5 288.5C273.581 312.327 304.604 349.784 327.067 376.906C331.472 382.225 335.548 387.147 339.185 391.49C367.402 373.431 406.884 353.443 406.884 353.443L440.18 362.473C440.18 362.473 430.999 381.336 406.884 400.747C405.49 401.87 403.356 403.856 400.583 406.437C387.797 418.339 361.405 442.906 331 454C301 438.5 274.5 416 253 375.5C248.5 416 262.775 576.778 264.673 580.869C269.24 590.756 278.217 606.238 278.217 606.238C278.217 606.238 108.844 692.485 58.0497 670.374C55.6815 669.35 52.2017 663.827 52.2017 663.827L52.6716 566.769C-58.69 468.994 -28.1758 453.131 -28.1758 453.131C-29.7958 419.863 -1.78647 332.589 19.4912 299.441C21.8241 295.807 24.7698 292.645 28.1137 289.896C28.7213 288.611 29.174 287.847 29.4142 287.653C32.7542 284.958 38.0304 282.587 44.0223 280.551C61.0464 273.339 79.7665 271.904 84.1087 271.66C84.3248 271.63 84.4378 271.615 84.4378 271.615C84.4378 271.615 84.4405 271.624 84.446 271.642Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.325 133.212C119.325 133.212 150.114 247.913 113.997 268.229C138.033 280.913 180.724 280.848 180.724 280.848L182.492 245.617C182.492 245.617 204.399 249.959 210.096 229.531C230.249 185.273 212.847 115.35 212.847 115.35L119.325 133.212Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.902 125.613C211.177 128.376 209.016 144.364 209.016 144.364L193.789 178.213C186.028 172.095 175.615 172.489 173.552 186.207C172.079 196.174 184.358 198.148 184.358 198.148C177.187 210.385 172.373 220.254 161.96 231.899C150.663 244.432 144.376 245.715 132.194 245.913H118.736C118.736 245.913 112.154 224.399 99.9725 170.614C86.4158 110.909 156.655 118.606 169.721 103.408C190.94 78.6379 251.651 116.83 220.902 125.613Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.965 83.5724C222.965 83.5724 220.215 85.6449 215.696 87.816C206.756 91.9608 190.842 96.3031 174.24 86.0396C171.685 84.4606 169.131 83.375 166.577 82.7829C145.26 77.3551 125.023 101.83 122.862 104.593C119.62 108.047 116.869 111.896 114.708 116.139C106.554 119.791 99.6777 126.205 95.5517 134.199C88.8716 147.127 89.9522 168.542 101.348 176.24L112.94 172.391C113.726 173.871 114.708 175.253 115.887 176.437C116.771 177.325 118.048 178.115 119.227 178.509C120.799 179.003 122.469 178.904 123.647 177.917C124.925 176.832 125.416 175.055 125.71 173.279C126.103 171.404 126.496 169.529 126.889 167.654L209.801 139.923C209.605 142.094 209.016 144.265 208.23 146.041C208.23 146.041 208.23 146.041 208.328 146.041C208.721 146.041 210.489 146.14 212.945 145.647C218.152 144.66 226.796 141.502 233.575 131.14C244.086 115.35 241.434 91.4674 222.965 83.5724Z",
    fill: "#4B4A50"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 80,
    width: 223,
    height: 113.644,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 98,
    width: 136,
    height: 18,
    rx: 9,
    fill: "#FF7D23"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 149.615,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 132,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 166.77,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.851 96L337.923 112.012L331.887 106.675L329 110.059L338.054 118L358 99.2544L354.851 96Z",
    fill: "#FF7D23",
    stroke: "#FF7D23",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 207,
    width: 223,
    height: 113.644,
    rx: 5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 225,
    width: 136,
    height: 18,
    rx: 9,
    fill: "#B7B7B9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 276.615,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 259,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 293.77,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.851 223L337.923 239.012L331.887 233.675L329 237.059L338.054 245L358 226.254L354.851 223Z",
    fill: "#787B7D",
    stroke: "#787B7D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.37 323.175C439.438 319.948 443.062 317.107 443.249 317.074C443.249 317.074 460.62 301.01 465.687 302.492C470.837 303.999 468.503 307.613 462.522 313.435C460.334 315.568 458.904 317.49 457.98 319.005C459.273 318.966 460.742 319.167 462.026 319.724C462.91 320.111 463.774 320.692 464.293 321.372C465.029 322.38 464.916 323.475 464.408 324.323C464.375 324.38 464.331 324.438 464.277 324.498C465.115 324.597 465.969 324.807 466.81 325.153C467.764 325.553 468.618 326.119 469.204 326.867C469.925 327.913 469.886 329.068 469.384 329.897C468.99 330.549 468.351 331.091 467.662 331.579L468.323 332.116C468.323 332.116 476.975 331.987 476.675 338.31C476.568 340.076 475.883 342.067 474.93 344.833L474.929 344.835L474.926 344.844C474.759 345.33 474.583 345.84 474.401 346.376C473.681 348.416 472.192 350.436 469.615 348.864C468.492 348.126 467.57 347.106 467.628 345.691C467.738 343.723 468.055 342.489 468.249 341.735C468.425 341.05 468.499 340.762 468.222 340.681C467.628 340.507 461.152 345.37 458.532 347.364L460.368 348.593C460.368 348.593 453.513 356.841 449.591 360.817C446.056 364.371 438.83 361.33 438.83 361.33L411.524 386.895L400.466 367.362L425.998 333.423L423.816 332.397C423.816 332.397 425.609 330.958 428.106 328.962C428.747 326.422 429.697 324.073 431.086 323.332C432.149 322.746 433.713 322.808 435.37 323.175Z",
    fill: "#D7AE88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M407 353.5L377.5 377C386.5 384.333 405.5 398.4 409.5 396C413.5 393.6 431.5 373 440 363C437.6 358.2 417 354.667 407 353.5Z",
    fill: "#E62645"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReminder);
export default __webpack_public_path__ + "static/media/icon-reminder.f235842aa65e7591ea51073fce2c1eda.svg";
export { ForwardRef as ReactComponent };